module.exports = __webpack_public_path__ + "static/media/bg_pets.f1f611a0.png";